import { normalizeError } from '../api/core/errors';

export function userErrorMessage(error: unknown): string {
  const normalized = normalizeError(error);

  switch (normalized.kind) {
    case 'network':
      return 'Không có kết nối mạng. Vui lòng kiểm tra kết nối rồi thử lại.';
    case 'timeout':
      return 'Yêu cầu mất quá nhiều thời gian. Vui lòng thử lại.';
    case 'unauthorized':
      return 'Phiên đăng nhập đã hết hạn. Vui lòng đăng nhập lại.';
    case 'forbidden':
      return 'Tài khoản không có quyền thực hiện thao tác này.';
    case 'notFound':
      return 'Không tìm thấy dữ liệu được yêu cầu.';
    case 'validation':
      return 'Dữ liệu chưa hợp lệ. Vui lòng kiểm tra và thử lại.';
    case 'canceled':
      return 'Yêu cầu đã được hủy.';
    case 'server':
      return 'Hệ thống đang gặp sự cố. Vui lòng thử lại sau.';
    default:
      return 'Không thể hoàn tất thao tác. Vui lòng thử lại.';
  }
}
